import React, { useEffect } from 'react';
import { InformationUpdateNew } from '@teliaee/crm-components';
import LoggingApi from '../api/LoggingApi';
import Config from '../Config';
import { InformationUpdatePageOld } from './InformationUpdatePageOld';
export const InformationUpdatePage = () => {
    useEffect(() => {
        LoggingApi.postLog(location.pathname);
    }, []);
    if (Config.environment === 'live') {
        return React.createElement(InformationUpdatePageOld, null);
    }
    return React.createElement(InformationUpdateNew, null);
};
